import { Fetcher } from "../../fetcher";
import { z } from "zod";

const signInErrorCodes = [z.literal("usernameExists"), z.literal("invalidPassword")] as const;

const schema = z.object({});

export type ApiSignUpOkResponse = z.infer<typeof schema>;
export type ApiSignUpRequest = { username: string; password: string };

export const signUp = (fetcher: Fetcher, data: { username: string; password: string }) => {
  return fetcher({
    endpoint: "/users/signUp",
    method: "POST",
    data,
    schema: z.object({}),
    errors: signInErrorCodes,
  });
};
